<template>
	<div>
		<campaigns-taxonomy
			v-for="taxonomy in taxonomies"
			v-bind:key="taxonomy.name"
			:taxonomy="taxonomy"
			:value="values[taxonomy.name]"
			:multi="shouldMultiSelect(taxonomy)"
			:postTypes="postTypes"
			@input="setTaxValue"
		>
			<template v-slot:label>{{ labelPrefix }}{{ taxonomy.label }}:</template>
		</campaigns-taxonomy>
	</div>
</template>

<script lang="js">
import { campaign } from '@/campaigns/mixins/campaign'
import { mapState } from 'vuex'

export default  {
	mixins : [ campaign ],
	props  : {
		/**
		 * The campaign object
		 *
		 * @type {Object}
		 */
		campaign : {
			type     : Object,
			required : true,
		},
		labelPrefix : {
			type    : String,
			default : 'Show on ',
		},
		/**
		 * Array of taxonomy objects.
		 *
		 * @type {[type]}
		 */
		taxonomies : Array,
	},
	computed : {
		...mapState('wp', {
			postTypes     : 'postTypes',
			allTaxonomies : 'taxonomies',
		}),
		values () {
			const values = {}
			Object.keys(this.$get('allTaxonomies', {})).forEach(t => {
				values[t] = this.$get(
					`campaign.wp.post_meta._omapi_${t}`,
					this.$get(`campaign.wp.post_meta._omapi_taxonomies.${t}`, [])
				)
			})

			return values
		},
	},
	methods : {
		setTaxValue ({ name, newValue }) {
			const key = 'categories' === name
				? `wp.post_meta._omapi_${name}`
				: `wp.post_meta._omapi_taxonomies[${name}]`

			this.updateCampaignValue({
				campaignId : this.id,
				key,
				value      : newValue,
				valueType  : 'array',
			})
		},
		shouldMultiSelect (taxonomy) {
			return 10 < (taxonomy.terms || []).length
		},
	},
}
</script>
